import { SPARKY_SERVER_URL } from '../components/shared/constants';

// Lightweight, best-effort usage telemetry — for the friends-and-family
// preview only, so we can see what got tested without having to ask.
// Never throws, never blocks the UI, and never sends anything if it fails.
//
// Each browser gets a random, anonymous device id (no name, no email) so
// separate testers' activity can be told apart without collecting identity.

const DEVICE_ID_KEY = 'lumio_device_id';

function getDeviceId() {
  try {
    let id = localStorage.getItem(DEVICE_ID_KEY);
    if (!id) {
      id = 'dev_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem(DEVICE_ID_KEY, id);
    }
    return id;
  } catch (_) {
    return 'unknown';
  }
}

export function trackEvent(type, details = {}) {
  try {
    const payload = {
      type,
      details,
      deviceId: getDeviceId(),
      ts: new Date().toISOString(),
      path: typeof window !== 'undefined' ? window.location.pathname + window.location.search : '',
    };
    const url = `${SPARKY_SERVER_URL}/api/telemetry`;
    const body = JSON.stringify(payload);
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      navigator.sendBeacon(url, blob);
    } else {
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true }).catch(() => {});
    }
  } catch (_) {
    // Telemetry must never break the app.
  }
}
